module.exports = __webpack_public_path__ + "static/img/img-sou.b1f4a7fc.png";